/**
 * @generated SignedSource<<dfcf9081e1640df3ad45f93216183420>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentVideo_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "HpSharedVideoComponentVideo_user";
};
export type HpSharedVideoComponentVideo_user$key = {
  readonly " $data"?: HpSharedVideoComponentVideo_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentVideo_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentVideo_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cefdc51a7a60e24d218b6b92d9c530ed";

export default node;
